import type { Component } from 'vue'

import type { RelationGroupType } from '../../constants/relations.ts'
import type { AlertType } from '../../constants/ui.ts'

type ModalComponent = Component

interface ModalAction {
  component: ModalComponent
  title: string
  type: 'modal'
}

interface RedirectAction {
  route: string
  type: 'redirect'
}

interface RefRedirectAction {
  type: 'ref-redirect'
}

interface SlideInAction {
  relationGroupType: RelationGroupType
  type: 'createRelationSlideIn'
  organizationRelationType?: string
}

interface AlertActionContext {
  targetDisabled?: boolean
}

interface AlertAction {
  alertType: AlertType
  cancelLabel: string
  ctaLabel: string
  message: string
  messageTitle: string
  onSubmit(doc_name: string, context?: AlertActionContext): Promise<void>
  type: 'alert'
}

type ActionMapEntry = AlertAction | ModalAction | RedirectAction | RefRedirectAction | SlideInAction

const isModalAction = (action: ActionMapEntry): action is ModalAction => {
  return action.type === 'modal'
}

const isRedirectAction = (action: ActionMapEntry): action is RedirectAction => {
  return action.type === 'redirect'
}

const isRefRedirectAction = (action: ActionMapEntry): action is RefRedirectAction => {
  return action.type === 'ref-redirect'
}

const isSlideInAction = (action: ActionMapEntry): action is SlideInAction => {
  return action.type === 'createRelationSlideIn'
}

const isAlertAction = (action: ActionMapEntry): action is AlertAction => {
  return action.type === 'alert'
}

export {
  type ActionMapEntry,
  type AlertActionContext,
  isAlertAction,
  isModalAction,
  isRedirectAction,
  isRefRedirectAction,
  isSlideInAction,
  type ModalAction,
  type ModalComponent,
  type RedirectAction,
  type RefRedirectAction,
  type SlideInAction,
}
